/* ============================================================
   TOMASHKO — the aliveness + commerce layer.
   intro · reveals · typing labels · accent drift · descent rail
   · cursor glow · menu/search/cart/popup · AJAX cart · variants
   · gallery · accordion · page transitions · email capture.
   All motion respects prefers-reduced-motion (resolves instantly).
   ============================================================ */
(function () {
  'use strict';
  var TK = window.TOMASHKO || {};
  // editor detection — disables page transitions / intro / pop-up / cart-nav inside the theme
  // editor so nothing hijacks navigation. Trust THREE signals: the Liquid flag, Shopify's own
  // client flag, OR being inside an iframe (the editor preview is always framed; the live store never is).
  try { if ((window.Shopify && window.Shopify.designMode) || window.self !== window.top) TK.designMode = true; } catch (e) { TK.designMode = true; }
  var mql = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var REDUCE = mql.matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };

  /* ---------- money (market-aware) ----------
     Shopify's AJAX endpoints return amounts in the shopper's PRESENTMENT currency (always ×100,
     even zero-decimal currencies like JPY). In the BASE market we format through the Liquid-bridged
     shop money_format so client-rendered prices are pixel-identical to server-rendered ones; in a
     CONVERTED market (Shopify.currency.rate ≠ 1, or an explicit currency from the cart response)
     we format with Intl.NumberFormat in the active currency — never the base symbol. No currency
     symbol is ever hardcoded here. */
  function shopifyCurrency() {
    try { return (window.Shopify && window.Shopify.currency) || null; } catch (e) { return null; }
  }
  function isConvertedMarket() {
    var sc = shopifyCurrency();
    if (!sc || sc.rate == null) return false;
    var r = parseFloat(sc.rate);
    return isFinite(r) && Math.abs(r - 1) > 1e-9;
  }
  function formatMoney(cents, currency) {
    var v = (Number(cents) || 0) / 100;
    var sc = shopifyCurrency();
    var active = currency || (sc && sc.active) || null;
    var converted = isConvertedMarket() || (currency && sc && sc.active && currency !== sc.active);
    if (active && converted) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: active }).format(v);
      } catch (e) { /* unknown code / old engine — fall through to the shop format */ }
    }
    var fmt = TK.moneyFormat || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return String(Math.round(v));
        case 'amount_with_comma_separator': return v.toFixed(2).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return String(Math.round(v));
        default: return v.toFixed(2);
      }
    });
  }
  function validEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }
  // HTML-escape for strings interpolated into innerHTML (cart line titles etc.) — mirrors Liquid's | escape
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- scroll lock (overlay-aware) ---------- */
  var openOverlays = {};
  function setLock() {
    var any = Object.keys(openOverlays).some(function (k) { return openOverlays[k]; });
    document.body.style.overflow = any ? 'hidden' : '';
  }

  /* ============================================================
     INTRO LOAD-UP — once per session, skippable, reduced-motion safe
     ============================================================ */
  // the hero copy only 'rises' when it was held for the intro (html.tk-intro); otherwise it is already painted — never re-hide it
  function revealHero() { var c = $('.hero .content'); if (c && document.documentElement.classList.contains('tk-intro')) c.classList.add('tk-rise'); document.documentElement.classList.remove('tk-pre'); }

  (function intro() {
    // STILLPOINT — the timeline is pure CSS (snippets/sigil-motion-head.liquid), gated in <head>
    // via html.tk-intro. JS only lets the hero copy rise as the cut opens, then removes the overlay.
    var el = document.getElementById('intro');
    var d = document.documentElement;
    if (!el || !d.classList.contains('tk-intro') || TK.designMode) { revealHero(); if (el) el.remove(); return; }
    var done = false;
    function go() { if (done) return; done = true; revealHero(); }
    // this deferred script can arrive after the cut has begun — schedule from the animation's own clock
    var h1 = el.querySelector('.ih1'), anim = h1 && h1.getAnimations ? h1.getAnimations()[0] : null;
    if (anim) { var left = (anim.effect.getComputedTiming().delay || 0) - (anim.currentTime || 0); setTimeout(go, Math.max(0, left)); }
    else go();
    el.addEventListener('animationstart', function (e) { if (e.animationName === 'tki-a2') go(); });   // tap-to-skip
    el.addEventListener('animationend', function (e) { if (e.target === el && /^tki-end/.test(e.animationName)) el.remove(); });
    setTimeout(go, 3000);                                   // failsafe: the copy never waits longer
    on(window, 'pageshow', function (e) { if (e.persisted) { el.remove(); go(); } });
  })();

  /* ---------- announcement-bar offset (robust to wrapped copy) ---------- */
  (function annOffset() {
    var bar = document.getElementById('annbar');
    if (!bar) return;
    function set() {
      var h = bar.offsetHeight;
      document.body.style.paddingTop = h + 'px';
      var hd = document.getElementById('hdr');
      if (hd) hd.style.top = h + 'px';
    }
    set();
    on(window, 'resize', set);
  })();

  /* ---------- LIGHT / DARK scheme switch (the no-flash initial state is set inline in <head>) ---------- */
  (function scheme() {
    var btn = document.querySelector('[data-scheme-toggle]');
    if (!btn) return;
    var KEY = 'tk-scheme';
    function apply(s) {
      document.documentElement.classList.toggle('scheme-light', s === 'light');
      document.documentElement.setAttribute('data-scheme', s);
      try { localStorage.setItem(KEY, s); } catch (e) {}
    }
    on(btn, 'click', function () {
      var nowLight = document.documentElement.classList.contains('scheme-light');
      apply(nowLight ? 'dark' : 'light');
      // re-base the inline drifted --accent-rgb onto the new scheme so translucent accents flip too
      if (typeof onScroll === 'function') onScroll();
    });
  })();

  /* ---------- drag-to-scroll for horizontal strips (desktop pointer; touch/trackpad scroll natively) ---------- */
  (function dragScroll() {
    $$('[data-drag-scroll]').forEach(function (track) {
      var down = false, startX = 0, startScroll = 0, moved = false;
      on(track, 'pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft; track.classList.add('is-dragging');
      });
      on(track, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX; if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function end() { down = false; track.classList.remove('is-dragging'); }
      on(track, 'pointerup', end); on(track, 'pointerleave', end);
      on(track, 'click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  })();

  /* ---------- TURNTABLE — shared drag-to-scrub engine (fitting section + PDP gallery) ----------
     RELATIVE drag, like turning a record: small drags register, big drags spin further; modulo
     wrap so it loops continuously; pointer capture so the drag survives leaving the stage;
     ArrowLeft/Right for keyboard. No inertia or settle animation — it lands exactly where the
     hand leaves it, so reduced-motion needs no special path here (frame cross-fades are CSS,
     gated there). Returns a tiny API: show(i) for external jumps (thumbs, variant images),
     index(), used() (has a real drag happened yet — drives the affordance fade). */
  function makeTurntable(stage, frames, opts) {
    opts = opts || {};
    var n = frames.length;
    if (n < 2) return null;
    var idx = 0, wasDrag = false;
    // suppress the browser's native image drag, which otherwise hijacks the pointer-drag
    $$('img', stage).forEach(function (im) { im.draggable = false; on(im, 'dragstart', function (e) { e.preventDefault(); }); });
    function show(i) {
      i = ((i % n) + n) % n;             // wrap — the turntable loops continuously
      if (i === idx) return;
      frames[idx].classList.remove('on'); frames[i].classList.add('on'); idx = i;
      if (opts.onChange) opts.onChange(i);
    }
    var down = false, startX = 0, startIdx = 0, moved = false;
    function sens() { var w = stage.getBoundingClientRect().width || 480; return Math.max(26, w / (n * 1.9)); }
    // opts.noDrag → pointer-drag scrubbing is disabled (PDP gallery uses explicit arrows instead);
    // show()/keyboard/click-to-zoom all still work. The homepage fitting turntable omits noDrag.
    if (!opts.noDrag) {
      on(stage, 'pointerdown', function (e) {
        down = true; moved = false; startX = e.clientX; startIdx = idx;
        stage.classList.add(opts.grabClass || 'fit-grab');
        if (stage.setPointerCapture) { try { stage.setPointerCapture(e.pointerId); } catch (_) {} }
      });
      on(stage, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          if (!wasDrag && opts.onFirstDrag) opts.onFirstDrag();
          moved = true; wasDrag = true;
        }
        show(startIdx + Math.round(dx / sens()));
      });
      var up = function () { down = false; stage.classList.remove(opts.grabClass || 'fit-grab'); };
      on(stage, 'pointerup', up); on(stage, 'pointercancel', up);
    }
    // click — after a REAL drag the trailing click is swallowed (capture phase, so it wins over
    // any later click binding on the same stage — the PDP zoom). A plain tap advances one frame
    // only where the caller asks for it (the fitting section); the gallery leaves taps to zoom.
    stage.addEventListener('click', function (e) {
      if (moved) { moved = false; e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (opts.clickAdvances) show(idx + 1);
    }, true);
    on(stage, 'keydown', function (e) {
      if (e.key === 'ArrowRight') { show(idx + 1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { show(idx - 1); e.preventDefault(); }
    });
    return { show: show, index: function () { return idx; }, used: function () { return wasDrag; } };
  }

  /* ---------- FITTING turntable — the homepage angle-scrub, now on the shared engine ---------- */
  (function fitting() {
    $$('[data-fitting]').forEach(function (v) {
      var frames = $$('.fit-frame', v);
      var indCur = v.parentNode ? v.parentNode.querySelector('.fit-ind-cur') : null;
      makeTurntable(v, frames, {
        clickAdvances: true,
        onChange: function (i) { if (indCur) indCur.textContent = ('0' + (i + 1)).slice(-2); }
      });
    });
  })();

  /* ---------- HERO crossfade slideshow — photos DISSOLVE (opacity), never slide. Interval + fade
     length are merchant-set (data-interval + CSS var --hero-fade from the section). One photo = static;
     under reduced-motion we hold the first photo. Pauses while the tab is hidden. ---------- */
  (function heroSlides() {
    var box = document.querySelector('[data-hero-slides]');
    if (!box) return;
    var slides = $$('.hero-slide', box);
    if (slides.length < 2) return;
    var active = 0, i;
    for (i = 0; i < slides.length; i++) { if (slides[i].classList.contains('on')) { active = i; break; } }
    // guarantee exactly one active slide
    for (i = 0; i < slides.length; i++) { slides[i].classList.toggle('on', i === active); }
    if (REDUCE) return;                                  // hold the first photo, no auto-advance
    var interval = Math.max(2000, parseInt(box.getAttribute('data-interval'), 10) || 5000);
    var timer = null;
    function advance() {
      slides[active].classList.remove('on');
      active = (active + 1) % slides.length;
      slides[active].classList.add('on');
    }
    function start() { if (!timer) timer = setInterval(advance, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    start();
    on(document, 'visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
  })();

  /* ============================================================
     REVEALS + TYPING LABELS (IntersectionObserver)
     ============================================================ */
  function typeLabels(scope) {
    if (REDUCE) return;
    $$('[data-type-label]', scope).forEach(function (el) {
      if (el.getAttribute('data-typed')) return;
      el.setAttribute('data-typed', '1');
      var full = el.textContent, i = 0;
      el.textContent = '';
      (function tick() { if (i <= full.length) { el.textContent = full.slice(0, i); i++; setTimeout(tick, 28); } })();
    });
  }
  var isHome = document.body.classList.contains('template-index');
  var revealEls = $$('.reveal, .block');
  // B1 — the homepage section wrappers also reveal, so the connecting construction seam between sections can draw in on the diagonal as you descend
  if (isHome) revealEls = revealEls.concat($$('main > .shopify-section'));
  // R9 — element-level content cascade: stamp .casc on each text-led section's lines (DOM order ≈
  // reading order, top→down) so the reveal observer can settle them in sequence. Driven per-child
  // because this engine only honours .in on the SAME node, never ancestor-.in→descendant overrides.
  // Skipped under reduced motion / no-IO so those paths render every line fully placed and static.
  if (isHome && !REDUCE && ('IntersectionObserver' in window)) {
    $$('.ritual, .feature, .veil, .constructseq, .manifesto').forEach(function (sec) {
      var i = 0;
      Array.prototype.forEach.call(sec.querySelectorAll('.eyebrow, .code, h1, h2, .line, p, .price, .cta'), function (k) {
        if (k.closest('.prow, .pcard')) return; // never cascade rail / card internals
        k.classList.add('casc'); k.setAttribute('data-casc', i++);
      });
    });
  }
  if (REDUCE || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('in'); typeLabels(el); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in'); typeLabels(en.target);
          var kids = en.target.querySelectorAll('.casc');
          if (kids.length) Array.prototype.forEach.call(kids, function (k) {
            var idx = +k.getAttribute('data-casc') || 0;
            setTimeout(function () { k.classList.add('in'); }, 90 + idx * 80);
          });
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ============================================================
     SCROLL: header state · accent drift · descent rail
     ============================================================ */
  var hdr = document.getElementById('hdr');
  var base = TK.accent || [230, 233, 236];    // silver-white fallback (monochrome) — never gold
  var cool = TK.accentCool || [174, 182, 189]; // cool silver drift target — no steel-blue hue
  // LIGHT EDITION accent — mirrors `.scheme-light{--accent-rgb}` in cd-pass.css. The drift writes an
  // inline --accent-rgb on <html>, which out-specifies the .scheme-light class; without re-basing per
  // scheme it would strand every translucent accent in light mode. Drift in light simply deepens the
  // same cool GRAPHITE (no hue shift) so it stays legible on the bright monochrome ground.
  var baseLight = [94, 100, 107];   // cool graphite — matches cd-pass.css .scheme-light --accent
  function isLight() { return document.documentElement.classList.contains('scheme-light'); }
  function curBase() { return isLight() ? baseLight : base; }
  var driftOn = TK.drift !== false && !REDUCE;
  function lerp(a, b, t) { return Math.round(a + (b - a) * t); }
  function driftTarget() {
    // achromatic drift ONLY — move between the base and the cool silver, never toward a hue
    if (isLight()) return [Math.round(baseLight[0] * 0.82), Math.round(baseLight[1] * 0.82), Math.round(baseLight[2] * 0.82)];
    return [Math.round((cool[0] + base[0]) / 2), Math.round((cool[1] + base[1]) / 2), Math.round((cool[2] + base[2]) / 2)];
  }
  // quantized write: lerp() already rounds each channel, so long scroll runs produce identical
  // triplets — skip the setProperty unless the value actually changed (every write invalidates
  // computed style for all var(--accent-rgb) consumers, a per-frame recalc storm otherwise).
  var lastAccent = '';
  function applyAccent(rgb) {
    var v = rgb[0] + ' ' + rgb[1] + ' ' + rgb[2];
    if (v === lastAccent) return;
    lastAccent = v;
    document.documentElement.style.setProperty('--accent-rgb', v);
  }
  // — descent spine: build from the live homepage sections —
  var spineEl = document.querySelector('[data-spine]');
  var spineTop = document.querySelector('[data-spine-top]');
  var spineItems = [], spineSections = [], spineFill = null, spineActive = -1;
  var spineHero = document.querySelector('.hero');
  function buildSpine() {
    if (!spineEl || !isHome) return;
    spineSections = $$('main .shopify-section').filter(function (s) { return s.querySelector('h1, h2') && !s.querySelector('.hero'); });
    if (spineSections.length < 2) return;
    var cluster = document.createElement('div'); cluster.className = 'spine-cluster';
    var railEl = document.createElement('div'); railEl.className = 'spine-rail';
    spineFill = document.createElement('div'); spineFill.className = 'spine-fill';
    railEl.appendChild(spineFill); cluster.appendChild(railEl);
    spineSections.forEach(function (s, i) {
      var h = s.querySelector('h1, h2');
      var label = (h ? h.innerHTML : '').replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]+>/g, '').replace(/†/g, 'T').replace(/\s+/g, ' ').trim();
      if (label.length > 20) label = label.slice(0, 19) + '…';
      var a = document.createElement('a');
      a.className = 'spine-item'; a.href = '#'; a.setAttribute('aria-label', label);
      a.innerHTML = '<span class="spine-n">' + ('0' + (i + 1)).slice(-2) + '</span><span class="spine-label">' + label + '</span>';
      a.addEventListener('click', function (e) { e.preventDefault(); s.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' }); });
      cluster.appendChild(a); spineItems.push(a);
    });
    spineEl.appendChild(cluster);
    requestAnimationFrame(function () { spineEl.classList.add('ready'); });
  }
  function updateSpine(t) {
    if (spineTop) spineTop.style.width = (t * 100) + '%';
    if (!spineItems.length) return;
    if (spineEl) { var past = spineHero ? spineHero.getBoundingClientRect().bottom < window.innerHeight * 0.5 : t > 0.06; spineEl.classList.toggle('live', past); }
    if (spineFill) spineFill.style.height = (t * 100) + '%';
    var line = window.innerHeight * 0.42, active = 0;
    for (var i = 0; i < spineSections.length; i++) { if (spineSections[i].getBoundingClientRect().top - 1 <= line) active = i; }
    if (active !== spineActive) { spineActive = active; spineItems.forEach(function (it, i) { it.classList.toggle('on', i === active); }); }
  }
  buildSpine();

  // — scroll hint: a top-of-page prompt; fade it out the moment we leave the top —
  var scrollLbl = document.querySelector('.scrolllabel');

  // — subtle scroll parallax on [data-parallax] frames (desktop, reduced-motion off) —
  var parallaxEls = REDUCE ? [] : $$('[data-parallax]');
  // layered depth — foreground elements drift at their OWN (often opposite) rate so
  // full-bleed moments read volumetric, not flat. Same conductor, no new listener.
  var driftEls = REDUCE ? [] : $$('[data-parallax-self]');
  // construction planes — [data-push] panels drift at independent rates so the composition reads as moving planes. Amplitude scales from --push-motion. Off under reduced-motion.
  var pushEls = REDUCE ? [] : $$('[data-push]');
  var pushMotion = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--push-motion')) || 1;
  // drop card — graceful delayed entrance, then fades out as the hero scrolls away.
  // Belongs to the hero moment; never persists awkwardly over later sections.
  // The card is position:fixed (bottom-right) so it FOLLOWS the page as you scroll. It stays
  // hidden for the entry delay, eases in wherever you are, rides along, then fades itself out
  // after its visible duration — a drop notification that arrives, follows, and bows out.
  var dropcard = document.querySelector('[data-dropcard]');
  var dcThresh = 0;
  if (dropcard) {
    if (REDUCE) {
      dropcard.classList.add('shown');
    } else {
      var dcDelay = parseInt(dropcard.getAttribute('data-delay'), 10) || 5000;
      var dcDur = parseInt(dropcard.getAttribute('data-duration'), 10);
      if (isNaN(dcDur)) dcDur = 6000;
      setTimeout(function () {
        dropcard.classList.add('shown');
        if (dcDur > 0) setTimeout(function () { dropcard.classList.add('dim'); }, dcDur);
      }, dcDelay);
    }
  }
  // signature scroll moment — the construction-sequence panels assemble (--assemble 0→1) as the pinned section scrolls
  var cseqEl = document.querySelector('[data-cseq]');
  function updateCseq() {
    if (!cseqEl) return;
    var range = cseqEl.offsetHeight - window.innerHeight;
    var prog = range > 0 ? (-cseqEl.getBoundingClientRect().top) / range : 1;
    var asm = Math.max(0, Math.min(1, (prog - 0.08) / 0.62));
    cseqEl.style.setProperty('--assemble', (asm * pushMotion + (1 - pushMotion)).toFixed(3));
  }
  function updatePush() {
    for (var i = 0; i < pushEls.length; i++) {
      var el = pushEls[i], r = el.getBoundingClientRect();
      var off = ((r.top + r.height / 2) - window.innerHeight / 2) / window.innerHeight;
      off = Math.max(-1, Math.min(1, off));
      var d = parseFloat(el.getAttribute('data-push')) || 0;
      el.style.translate = '0 ' + (off * d * pushMotion).toFixed(1) + 'px';
    }
  }

  // — DISTORTED FLOW: content shears with scroll velocity, then settles (the page as moving fabric) —
  var FLOW_SHEAR = false;
  var rootEl = document.documentElement, flowTarget = 0, flowCur = 0, flowLast = window.pageYOffset, flowRAF = false;
  function flowTick() {
    flowCur += (flowTarget - flowCur) * 0.2;
    flowTarget *= 0.82;
    rootEl.style.setProperty('--flow-skew', flowCur.toFixed(3) + 'deg');
    if (Math.abs(flowCur) > 0.012 || Math.abs(flowTarget) > 0.012) requestAnimationFrame(flowTick);
    else { rootEl.style.setProperty('--flow-skew', '0deg'); flowCur = 0; flowRAF = false; }
  }

  // — cursor-reactive hero: the shard eases toward the pointer (desktop, motion on) —
  (function heroTilt() {
    if (REDUCE || !window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var tx = 0, ty = 0, cx = 0, cy = 0, htRAF = false;
    function htTick() {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      rootEl.style.setProperty('--hero-px', (cx * pushMotion).toFixed(3));
      rootEl.style.setProperty('--hero-py', (cy * pushMotion).toFixed(3));
      if (Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002) requestAnimationFrame(htTick);
      else htRAF = false;
    }
    function kick() { if (!htRAF) { htRAF = true; requestAnimationFrame(htTick); } }
    on(hero, 'mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      kick();
    });
    on(hero, 'mouseleave', function () { tx = 0; ty = 0; kick(); });
  })();
  function updateParallax() {
    for (var i = 0; i < parallaxEls.length; i++) {
      var el = parallaxEls[i];
      var img = el.querySelector ? el.querySelector('img.fill, img') : null;
      if (!img) continue;
      var r = el.getBoundingClientRect();
      var off = ((r.top + r.height / 2) - window.innerHeight / 2) / window.innerHeight;
      off = Math.max(-0.6, Math.min(0.6, off));
      var d = parseFloat(el.getAttribute('data-parallax')) || 6;
      img.style.translate = '0 ' + (off * -d * pushMotion).toFixed(2) + '%';
    }
    for (var k = 0; k < driftEls.length; k++) {
      var de = driftEls[k];
      var dr = de.getBoundingClientRect();
      var doff = ((dr.top + dr.height / 2) - window.innerHeight / 2) / window.innerHeight;
      doff = Math.max(-0.7, Math.min(0.7, doff));
      var dd = parseFloat(de.getAttribute('data-parallax-self')) || 4;
      de.style.translate = '0 ' + (doff * -dd * pushMotion).toFixed(2) + 'px';
    }
  }

  function onScroll() {
    var y = window.pageYOffset;
    // R23: the velocity shear ("distorted flow") is OFF — re-writing a root CSS variable every
    // scroll frame forced a full-page restyle + re-skew of every image, which read as stutter.
    if (FLOW_SHEAR && !REDUCE) {
      var fv = y - flowLast; flowLast = y;
      flowTarget = Math.max(-1.1, Math.min(1.1, fv * 0.026 * pushMotion));
      if (!flowRAF) { flowRAF = true; requestAnimationFrame(flowTick); }
    }
    if (hdr) { if (y > 60) hdr.classList.add('scrolled'); else hdr.classList.remove('scrolled'); }
    if (scrollLbl) { var sl = Math.max(0, 1 - y / 120); scrollLbl.style.opacity = sl; scrollLbl.style.pointerEvents = sl < 0.05 ? 'none' : ''; }
    if (parallaxEls.length || driftEls.length) updateParallax();
    if (pushEls.length) updatePush();
    if (cseqEl && !REDUCE) updateCseq();
    if (isHome) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var t = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
      // R23: scroll-linked accent drift OFF for the same reason (root --accent-rgb change = whole-page restyle per frame)
      if (driftOn && FLOW_SHEAR) {
        var s = t * t * (3 - 2 * t), tg = driftTarget(), b0 = curBase();
        applyAccent([lerp(b0[0], tg[0], s), lerp(b0[1], tg[1], s), lerp(b0[2], tg[2], s)]);
      }
      updateSpine(t);
    }
  }
  var ticking = false;
  on(window, 'scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { onScroll(); ticking = false; }); } }, { passive: true });
  on(window, 'resize', onScroll);
  onScroll();

  /* ============================================================
     CURSOR PRESENCE (desktop only)
     ============================================================ */
  (function cursor() {
    var g = document.getElementById('cursorglow');
    if (!g || TK.cursor === false || REDUCE) return;
    if (!window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    // glow tracks the pointer 1:1 (was an eased loop — that trailing halo read as float/bounce). The softness now comes only from the gradient, not from lag.
    on(document, 'mousemove', function (e) { g.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px) translate(-50%,-50%)'; document.body.classList.add('cursoractive'); });
    on(document, 'mouseleave', function () { document.body.classList.remove('cursoractive'); });
  })();

  /* ============================================================
     REGISTRATION-TICK CURSOR (desktop) — the brand crosshair replaces the
     system arrow and opens into a rotated target over interactive elements.
     Touch / reduced-motion / no-fine-pointer never see it (system cursor stays).
     ============================================================ */
  (function tickCursor() {
    var t = document.getElementById('cursortick');
    if (!t || TK.cursorMark === false || REDUCE) return;
    if (!window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    document.body.classList.add('tickcursor');
    var SEL = 'a,button,[role="button"],input,select,textarea,label,summary,.sw,.size,[data-ps-size],[data-quick-add],[data-wish]';
    var shown = false;
    on(document, 'mousemove', function (e) {
      // pixel-locked to the pointer — no easing, no lag, no settle-bounce on click
      t.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
      if (!shown) { shown = true; t.style.opacity = '1'; }
      t.classList.toggle('over', !!(e.target && e.target.closest && e.target.closest(SEL)));
    });
    on(document, 'mouseleave', function () { t.style.opacity = '0'; });
    on(document, 'mouseenter', function () { t.style.opacity = '1'; });
    // no click animation — a normal cursor doesn't change on click (the press pulse read as a "bounce").
  })();

  /* ============================================================
     MAGNETIC BUTTONS (desktop) — key CTAs lean toward the pointer as it nears,
     eased per-frame. No CSS transition is touched, so existing hovers stay intact.
     ============================================================ */
  (function magnetic() {
    if (TK.magnetic === false || REDUCE) return;
    if (!window.matchMedia || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var els = $$('.cta,.atc,.bin,.ps-add,.intro-enter,[data-magnetic]').map(function (el) { return { el: el, x: 0, y: 0, tx: 0, ty: 0 }; });
    if (!els.length) return;
    // kick-and-park (heroTilt pattern): the loop only runs while the pointer is active or an
    // element is still settling — no permanent per-frame layout reads on an idle page.
    var mx = -99999, my = -99999, mgRAF = false, mgMovedAt = 0, MG_IDLE = 300;
    function loop() {
      var settled = true;
      for (var i = 0; i < els.length; i++) {
        var o = els[i], r = o.el.getBoundingClientRect();
        if (r.width) {
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2, dx = mx - cx, dy = my - cy;
          var reach = Math.max(r.width, r.height) / 2 + 64;
          if (dx * dx + dy * dy < reach * reach) { o.tx = dx * 0.3; o.ty = dy * 0.3; } else { o.tx = 0; o.ty = 0; }
        }
        o.x += (o.tx - o.x) * 0.18; o.y += (o.ty - o.y) * 0.18;
        if (o.tx === 0 && o.ty === 0 && Math.abs(o.x) < 0.06 && Math.abs(o.y) < 0.06) { if (o.el.style.transform) { o.el.style.transform = ''; o.x = 0; o.y = 0; } }
        else { o.el.style.transform = 'translate(' + o.x.toFixed(2) + 'px,' + o.y.toFixed(2) + 'px)'; settled = false; }
      }
      if (!settled || Date.now() - mgMovedAt < MG_IDLE) requestAnimationFrame(loop);
      else mgRAF = false;
    }
    function kick() { if (!mgRAF) { mgRAF = true; requestAnimationFrame(loop); } }
    on(document, 'mousemove', function (e) { mx = e.clientX; my = e.clientY; mgMovedAt = Date.now(); kick(); });
  })();

  /* ============================================================
     RECENTLY VIEWED — PDP records a minimal card to localStorage; the rail
     section renders the most recent (excluding the current product). No app.
     ============================================================ */
  (function recentlyViewed() {
    var KEY = 'tk_recent';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 12))); } catch (e) {} }
    var rp = document.querySelector('[data-recent-product]');
    var curHandle = rp ? rp.getAttribute('data-handle') : null;
    if (rp && curHandle) {
      var item = { handle: curHandle, title: rp.getAttribute('data-title'), url: rp.getAttribute('data-url'), image: rp.getAttribute('data-image'), price: rp.getAttribute('data-price') };
      var a = read().filter(function (x) { return x.handle !== curHandle; });
      a.unshift(item); write(a);
    }
    var rail = document.querySelector('[data-recent-rail]');
    if (!rail) return;
    var max = parseInt(rail.getAttribute('data-recent-max'), 10) || 4;
    var items = read().filter(function (x) { return x.handle && x.handle !== curHandle; }).slice(0, max);
    if (!items.length) return;
    items.forEach(function (x) {
      var card = document.createElement('a'); card.className = 'recent-card'; card.href = x.url || '#';
      var im = document.createElement('span'); im.className = 'recent-img';
      if (x.image) { var img = document.createElement('img'); img.src = x.image; img.alt = ''; img.loading = 'lazy'; im.appendChild(img); }
      var t = document.createElement('span'); t.className = 'recent-t'; t.textContent = x.title || '';
      card.appendChild(im); card.appendChild(t);
      if (x.price) { var p = document.createElement('span'); p.className = 'recent-p'; p.textContent = x.price; card.appendChild(p); }
      rail.appendChild(card);
    });
    var sec = document.querySelector('[data-recent-section]'); if (sec) sec.hidden = false;
  })();

  /* ============================================================
     WISHLIST — localStorage "Saved". Hearts on cards/PDP toggle; the Saved
     drawer renders client-side. No account / app.
     ============================================================ */
  (function wishlist() {
    var KEY = 'tk_wish';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 60))); } catch (e) {} }
    function has(h) { return read().some(function (x) { return x.handle === h; }); }
    function updateCount() { var n = read().length; $$('[data-wish-count]').forEach(function (el) { el.textContent = n < 10 ? '0' + n : n; el.classList.toggle('is-empty', n === 0); }); }   /* registration-index format (01, 02…) — revert: el.textContent = n; */
    function syncButtons() { $$('[data-wish]').forEach(function (b) { var on = has(b.getAttribute('data-handle')); b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
    var rail = document.querySelector('[data-wish-rail]'), empty = document.querySelector('[data-wish-empty]');
    function renderDrawer() {
      if (!rail) return;
      var items = read(); rail.innerHTML = ''; if (empty) empty.hidden = items.length > 0;
      items.forEach(function (x) {
        var card = document.createElement('div'); card.className = 'wishcard';
        var a = document.createElement('a'); a.className = 'wishcard-l'; a.href = x.url || '#';
        var im = document.createElement('span'); im.className = 'wishcard-img';
        if (x.image) { var img = document.createElement('img'); img.src = x.image; img.alt = ''; img.loading = 'lazy'; im.appendChild(img); }
        var meta = document.createElement('span'); meta.className = 'wishcard-meta';
        var t = document.createElement('span'); t.className = 'wishcard-t'; t.textContent = x.title || ''; meta.appendChild(t);
        if (x.price) { var p = document.createElement('span'); p.className = 'wishcard-p'; p.textContent = x.price; meta.appendChild(p); }
        a.appendChild(im); a.appendChild(meta);
        var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'wishcard-rm'; rm.setAttribute('data-wish-remove', x.handle); rm.setAttribute('aria-label', 'Remove'); rm.innerHTML = '&times;';
        card.appendChild(a); card.appendChild(rm); rail.appendChild(card);
      });
    }
    on(document, 'click', function (e) {
      var rm = e.target.closest('[data-wish-remove]');
      if (rm) { e.preventDefault(); var hr = rm.getAttribute('data-wish-remove'); write(read().filter(function (x) { return x.handle !== hr; })); updateCount(); syncButtons(); renderDrawer(); return; }
      var b = e.target.closest('[data-wish]'); if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var h = b.getAttribute('data-handle'), a = read();
      if (has(h)) { a = a.filter(function (x) { return x.handle !== h; }); }
      else { a.unshift({ handle: h, title: b.getAttribute('data-title'), url: b.getAttribute('data-url'), image: b.getAttribute('data-image'), price: b.getAttribute('data-price') }); }
      write(a); updateCount(); syncButtons(); renderDrawer();
    });
    updateCount(); syncButtons(); renderDrawer();
  })();

  /* ============================================================
     QUICK ADD — single-variant adds straight to the cart vault; multi-variant
     sends to the product to choose a size. (addToCart / openCart reused.)
     ============================================================ */
  (function quickAdd() {
    on(document, 'click', function (e) {
      var b = e.target.closest('[data-quick-add]'); if (!b || b.disabled) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (b.getAttribute('data-single') === '1' && b.getAttribute('data-vid')) {
        b.classList.add('loading');
        addToCart(b.getAttribute('data-vid'), 1).then(function () {
          var orig = b.textContent; b.classList.remove('loading'); b.classList.add('added'); b.textContent = 'Added';
          refreshCart(true);   // refresh items + "Pairs with" and open the drawer (was openCart — left items stale)
          setTimeout(function () { b.textContent = orig; b.classList.remove('added'); }, 1500);
        }).catch(function () { b.classList.remove('loading'); });
      } else {
        var card = b.closest('a[href]'); if (card) location.href = card.getAttribute('href');
      }
    });
  })();

  /* ============================================================
     PREDICTIVE SEARCH — live product results from /search/suggest.json.
     ============================================================ */
  (function predictiveSearch() {
    var input = document.querySelector('[data-search-input]'), results = document.querySelector('[data-search-results]');
    if (!input || !results) return;
    var suggest = document.querySelector('.searchsuggest'), timer;
    function clear() { results.innerHTML = ''; results.hidden = true; if (suggest) suggest.hidden = false; }
    function run(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== input.value.trim()) return;
          var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
          results.innerHTML = '';
          if (!prods.length) { var e = document.createElement('div'); e.className = 'searchempty'; e.textContent = 'No matches yet.'; results.appendChild(e); results.hidden = false; if (suggest) suggest.hidden = true; return; }
          prods.forEach(function (p) {
            var a = document.createElement('a'); a.className = 'searchres'; a.href = p.url || '#';
            var im = document.createElement('span'); im.className = 'searchres-img';
            if (p.featured_image && p.featured_image.url) { var img = document.createElement('img'); img.src = p.featured_image.url; img.alt = ''; img.loading = 'lazy'; im.appendChild(img); }
            var t = document.createElement('span'); t.className = 'searchres-t'; t.textContent = p.title || '';
            a.appendChild(im); a.appendChild(t);
            if (p.price != null) {
              // suggest.json may return decimal-unit strings ("85.00") or cent integers — normalise to cents
              var praw = String(p.price);
              var pcents = praw.indexOf('.') > -1 ? Math.round(parseFloat(praw) * 100) : (parseInt(praw, 10) || 0);
              var pr = document.createElement('span'); pr.className = 'searchres-p'; pr.textContent = formatMoney(pcents); a.appendChild(pr);
            }
            results.appendChild(a);
          });
          results.hidden = false; if (suggest) suggest.hidden = true;
        }).catch(function () {});
    }
    on(input, 'input', function () {
      var q = input.value.trim(); clearTimeout(timer);
      if (q.length < 2) { clear(); return; }
      timer = setTimeout(function () { run(q); }, 220);
    });
  })();

  /* ============================================================
     GIFTING — "This is a gift" + message → cart attributes (Shopify-native).
     ============================================================ */
  (function cartGift() {
    function updateAttr(attrs) { try { fetch(((TK.routes && TK.routes.cart) || '/cart') + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }); } catch (e) {} }
    var msgTimer;
    on(document, 'change', function (e) {
      var tg = e.target.closest('[data-gift-toggle]'); if (!tg) return;
      var body = document.querySelector('[data-gift-body]'), msg = document.querySelector('[data-gift-message]');
      if (body) body.hidden = !tg.checked;
      updateAttr({ 'Gift': tg.checked ? 'Yes' : '', 'Gift message': (tg.checked && msg) ? msg.value : '' });
    });
    on(document, 'input', function (e) {
      var m = e.target.closest('[data-gift-message]'); if (!m) return;
      clearTimeout(msgTimer); msgTimer = setTimeout(function () { updateAttr({ 'Gift message': m.value }); }, 600);
    });
  })();

  /* ============================================================
     DROP COUNTDOWN — ticks to a launch datetime, then flips to a live state.
     ============================================================ */
  (function dropCountdown() {
    $$('[data-dropcount]').forEach(function (sec) {
      var target = new Date(sec.getAttribute('data-target') || '').getTime();
      if (isNaN(target)) return;
      var clock = sec.querySelector('[data-dropclock]'), live = sec.querySelector('[data-dropcount-live]');
      var dEl = sec.querySelector('[data-dc-d]'), hEl = sec.querySelector('[data-dc-h]'), mEl = sec.querySelector('[data-dc-m]'), sEl = sec.querySelector('[data-dc-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { if (clock) clock.hidden = true; if (live) live.hidden = false; return; }
        var s = Math.floor(diff / 1000), d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600; var m = Math.floor(s / 60); s -= m * 60;
        if (dEl) dEl.textContent = pad(d); if (hEl) hEl.textContent = pad(h); if (mEl) mEl.textContent = pad(m); if (sEl) sEl.textContent = pad(s);
        setTimeout(tick, 1000);
      }
      tick();
    });
  })();

  /* ============================================================
     OVERLAYS: menu · search · cart · popup
     ============================================================ */
  var lastFocus = null, activeScrim = null;
  function openOverlay(scrimId, key, focusSel) {
    var s = document.getElementById(scrimId); if (!s) return;
    lastFocus = document.activeElement; activeScrim = s;
    s.classList.add('open'); openOverlays[key] = true; setLock();
    var f = focusSel ? s.querySelector(focusSel) : null; if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 280);
  }
  function closeOverlay(scrimId, key) {
    var s = document.getElementById(scrimId); if (!s) return;
    s.classList.remove('open'); openOverlays[key] = false; setLock();
    if (activeScrim === s) activeScrim = null;
    // focus return — send focus back to whatever opened the overlay (a11y)
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} lastFocus = null; }
  }
  // focus trap — keep Tab within the open overlay
  function trapTab(e) {
    if (e.key !== 'Tab' || !activeScrim) return;
    var foci = Array.prototype.filter.call(
      activeScrim.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
    if (!foci.length) return;
    var first = foci[0], last = foci[foci.length - 1], a = document.activeElement;
    if (!activeScrim.contains(a)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  on(document, 'keydown', trapTab);
  function syncMenuBtn(expanded) { var b = document.querySelector('[data-menu-open]'); if (b) b.setAttribute('aria-expanded', expanded ? 'true' : 'false'); }
  var openMenu = function () { openOverlay('menuscrim', 'menu'); syncMenuBtn(true); }, closeMenu = function () { closeOverlay('menuscrim', 'menu'); syncMenuBtn(false); };
  var openSearch = function () { openOverlay('searchscrim', 'search', '[data-search-input]'); }, closeSearch = function () { closeOverlay('searchscrim', 'search'); };
  var openCart = function () { openOverlay('cartscrim', 'cart'); }, closeCart = function () { closeOverlay('cartscrim', 'cart'); };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); }
    else if (t.closest('[data-menu-close]')) { e.preventDefault(); closeMenu(); }
    else if (t.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (t.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    else if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    else if (t.closest('[data-cart-close]')) { closeCart(); }
    else if (t.closest('[data-ic-open]')) { e.preventDefault(); openIC(true); }
    else if (t.closest('[data-ic-close]')) { e.preventDefault(); closeIC(); }
    else if (t.closest('[data-size-guide-open]')) { e.preventDefault(); openOverlay('sgscrim', 'sg'); }
    else if (t.closest('[data-sg-close]')) { e.preventDefault(); closeOverlay('sgscrim', 'sg'); }
    else if (t.closest('[data-wish-open]')) { e.preventDefault(); openOverlay('wishscrim', 'wish'); }
    else if (t.closest('[data-wish-close]')) { e.preventDefault(); closeOverlay('wishscrim', 'wish'); }
  });
  // scrim background click closes
  ['menuscrim:menu', 'searchscrim:search', 'cartscrim:cart', 'icscrim:ic', 'sgscrim:sg', 'wishscrim:wish'].forEach(function (pair) {
    var p = pair.split(':'), el = document.getElementById(p[0]);
    on(el, 'click', function (e) { if (e.target === el) closeOverlay(p[0], p[1]); });
  });
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closeSearch(); closeCart(); closeIC(); closeOverlay('sgscrim', 'sg'); closeOverlay('wishscrim', 'wish'); }
  });
  // size-guide cm/in toggle — numbers only in the cells (the unit lives in the line above the
  // table); inches = cm ÷ 2.54 to 1 dp. The choice is remembered (localStorage, failure-safe).
  (function sizeUnits() {
    // one switch for every size table on the page (product drawer + the Size & Fit page charts)
    var KEY = 'tk_sg_unit';
    if (!document.querySelector('[data-cm]') && !document.getElementById('sgscrim')) return;
    function apply(unit) {
      $$('[data-unit]').forEach(function (x) { var onx = x.getAttribute('data-unit') === unit; x.classList.toggle('on', onx); x.setAttribute('aria-pressed', onx ? 'true' : 'false'); });
      $$('[data-cm]').forEach(function (cell) {
        var cm = parseFloat(cell.getAttribute('data-cm'));
        if (isNaN(cm)) return;
        cell.textContent = unit === 'in' ? (Math.round(cm / 2.54 * 10) / 10).toFixed(1) : cell.getAttribute('data-cm');
      });
      $$('[data-sg-unitword]').forEach(function (w) { w.textContent = unit === 'in' ? 'inches' : 'centimetres'; });
    }
    var saved = 'cm'; try { saved = localStorage.getItem(KEY) === 'in' ? 'in' : 'cm'; } catch (e) {}
    if (saved === 'in') apply('in');
    on(document, 'click', function (e) {
      var b = e.target.closest('[data-unit]'); if (!b) return;
      var unit = b.getAttribute('data-unit') === 'in' ? 'in' : 'cm';
      apply(unit);
      try { localStorage.setItem(KEY, unit); } catch (er) {}
    });
  })();
  // close menu when a nav link is followed (transition handles the rest)
  $$('[data-menu-scrim] [data-nav]').forEach(function (a) { on(a, 'click', function () { closeMenu(); }); });

  /* ============================================================
     AJAX CART (vault) → Shopify cart + native checkout
     ============================================================ */
  var R = TK.routes || {};
  function addJs() { return (R.cartAdd || '/cart/add') + '.js'; }
  function changeJs() { return (R.cartChange || '/cart/change') + '.js'; }
  function cartJs() { return (R.cart || '/cart') + '.js'; }

  function cartLineHTML(it, idx, currency) {
    var code = it.product_type || (it.sku ? String(it.sku).split('-')[0] : '') || '';
    var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? it.variant_title : '';
    return '<div class="citem" data-cart-line="' + (idx + 1) + '" data-key="' + esc(it.key) + '">' +
      '<div class="cthumb">' + (it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" width="80" height="100">' : '') + '</div>' +
      '<div class="cmeta"><div class="ccode">' + esc(code) + '</div>' +
      '<div class="cname"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></div>' +
      (variant ? '<div class="cvar">' + esc(variant) + '</div>' : '') +
      '<div class="cqty"><button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
      '<span data-qty>' + it.quantity + '</span><button type="button" data-qty-up aria-label="Increase">+</button></div></div>' +
      '<div class="cprice">' + formatMoney(it.final_line_price, currency) + '</div></div>';
  }
  function updateShipMeter(totalPrice, currency) {
    var fs = (window.TOMASHKO && window.TOMASHKO.freeShip) || null;
    var wrap = document.querySelector('#cartdrawer [data-cart-ship]');
    if (!wrap || !fs || !fs.on || !fs.threshold) return;
    // the threshold is a BASE-currency amount — in a converted market both the arithmetic and the
    // promise are wrong (200 JPY is not 200 GBP), so the meter stands down rather than mislead (EVAL 6.2)
    if (isConvertedMarket()) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var remain = fs.threshold - totalPrice;
    var pct = Math.max(0, Math.min(100, totalPrice / fs.threshold * 100));
    var fill = wrap.querySelector('[data-ship-fill]'), msg = wrap.querySelector('[data-ship-msg]');
    if (fill) fill.style.width = pct + '%';
    if (msg) msg.textContent = remain > 0
      ? (fs.progress || '[amount] away from complimentary shipping').replace('[amount]', formatMoney(remain, currency))
      : (fs.success || 'Complimentary shipping unlocked');
    wrap.classList.toggle('unlocked', remain <= 0);
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (c) {
      c.textContent = cart.item_count < 10 ? '0' + cart.item_count : cart.item_count;   /* registration-index format (01, 02…) — revert: c.textContent = cart.item_count; */
      c.classList.toggle('is-empty', cart.item_count === 0);
      if (cart.item_count > 0) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
    });
    var items = document.getElementById('cartitems'),
      empty = document.getElementById('cartempty'),
      foot = document.getElementById('cartfoot'),
      sub = document.querySelector('[data-cart-subtotal]');
    if (!items) return;
    if (cart.item_count === 0) {
      if (empty) empty.classList.remove('hidden');
      if (foot) foot.classList.add('hidden');
      items.innerHTML = '';
    } else {
      if (empty) empty.classList.add('hidden');
      if (foot) foot.classList.remove('hidden');
      items.innerHTML = cart.items.map(function (it, i) { return cartLineHTML(it, i, cart.currency); }).join('');
      if (sub) sub.textContent = formatMoney(cart.total_price, cart.currency);
      updateShipMeter(cart.total_price, cart.currency);
    }
    refreshPairs(cart.item_count);
    refreshGift(cart.item_count);
  }
  // complimentary-gift prompt (sections/cart-gift.liquid) — re-rendered server-side so the
  // threshold maths and "already in cart" state always match the real cart.
  function refreshGift(count) {
    var host = document.getElementById('cartgiftslot'); if (!host) return;
    if (count === 0) { host.innerHTML = ''; return; }
    fetch(location.pathname + '?section_id=cart-gift', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { host.innerHTML = html; })
      .catch(function () {});
  }
  // re-fetch the curated "Pairs with" suggestion (Section Rendering API). Cart is global, so the
  // section resolves in isolation. Renders nothing when nothing is curated / all pairs are in cart.
  function refreshPairs(count) {
    var host = document.getElementById('cartpairs'); if (!host) return;
    if (count === 0) { host.innerHTML = ''; return; }
    fetch(location.pathname + '?section_id=cart-pairs', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { host.innerHTML = html; })
      .catch(function () {});
  }
  function refreshCart(open) {
    return fetch(cartJs(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); return cart; })
      .catch(function () {});
  }
  function addToCart(id, qty) {
    return fetch(addJs(), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      // Shopify returns 422 + {status, description} when an item can't be added (sold out / inventory
      // race on drop day). Reject so callers can recover instead of treating the error as a success.
      return r.json().then(function (data) {
        if (!r.ok) { throw new Error((data && (data.description || data.message)) || 'Unavailable — try again'); }
        return data;
      });
    });
  }
  // flash a transient error on a buy button, then restore its original markup (arrow included)
  function atcError(btn, err) {
    if (!btn) return;
    btn.classList.remove('loading');
    if (!btn.getAttribute('data-html')) btn.setAttribute('data-html', btn.innerHTML);
    btn.classList.add('atc-error');
    btn.textContent = (err && err.message) ? err.message : 'Unavailable — try again';
    setTimeout(function () { btn.classList.remove('atc-error'); btn.innerHTML = btn.getAttribute('data-html'); }, 2800);
  }
  function changeQty(key, qty) {
    return fetch(changeJs(), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }
  // qty steppers inside the drawer
  on(document.getElementById('cartitems'), 'click', function (e) {
    if (!e.target || !e.target.closest) return;            // guard: click target may be a non-Element
    var line = e.target.closest('[data-key]'); if (!line) return;
    var key = line.getAttribute('data-key'), qEl = line.querySelector('[data-qty]');
    if (!qEl) return;                                       // guard: missing qty node (was a hard crash)
    var q = parseInt(qEl.textContent, 10); if (isNaN(q)) return;
    if (e.target.closest('[data-qty-up]')) changeQty(key, q + 1);
    else if (e.target.closest('[data-qty-down]')) changeQty(key, q - 1);
  });

  /* ---------- CART PAGE (/cart) — drive the native updates[] inputs + a Remove control ---------- */
  // The drawer is the primary surface; the /cart page is the no-JS-safe fallback. Here we make its
  // dead steppers live by writing the native name="updates[]" number input (the value Shopify reads
  // on submit), then submitting the form's own update so totals + line prices re-render server-side —
  // robust, native, no markup change needed. A Remove control is injected per row (markup has none)
  // and zeroes the line. Reduced motion is irrelevant (no animation); fully keyboard-operable.
  (function cartPage() {
    var form = document.querySelector('[data-cart-page-form]'); if (!form) return;
    var submitting = false;
    function submitUpdate() {
      if (submitting) return; submitting = true;
      form.classList.add('updating');
      $$('.cartpage-actions button, .cprow button', form).forEach(function (b) { b.disabled = true; });
      // submit via a synthesised update button so Shopify processes updates[] (not checkout)
      var btn = form.querySelector('button[name="update"]');
      if (btn) { btn.disabled = false; btn.click(); }
      else {
        var hid = document.createElement('input'); hid.type = 'hidden'; hid.name = 'update'; hid.value = '';
        form.appendChild(hid); form.submit();
      }
    }
    function rowInput(row) { return row.querySelector('[data-qty-input], input[name="updates[]"]'); }
    function setQty(row, q) {
      var input = rowInput(row); if (!input) return;
      if (q < 0) q = 0;
      input.value = q;
      submitUpdate();
    }
    // inject a Remove control into each row (markup owns no remove element)
    $$('.cprow', form).forEach(function (row) {
      if (row.querySelector('[data-cart-remove]')) return;
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cprow-remove';
      rm.setAttribute('data-cart-remove', '');
      rm.setAttribute('aria-label', 'Remove item');
      rm.textContent = 'Remove';
      rm.style.cssText = 'background:none;border:0;color:var(--muted);font-family:var(--ui);font-size:9px;letter-spacing:.2em;text-transform:uppercase;cursor:pointer;padding:6px 0;margin-top:8px;transition:color .3s';
      on(rm, 'mouseenter', function () { rm.style.color = 'rgb(var(--accent-rgb) / .95)'; });
      on(rm, 'mouseleave', function () { rm.style.color = ''; });
      var meta = row.querySelector('.cmeta') || row;
      meta.appendChild(rm);
    });
    on(form, 'click', function (e) {
      var row = e.target.closest('.cprow'); if (!row) return;
      var input = rowInput(row); if (!input) return;
      var q = parseInt(input.value, 10); if (isNaN(q)) q = 0;
      if (e.target.closest('[data-cart-remove]')) { e.preventDefault(); setQty(row, 0); }
      else if (e.target.closest('[data-qty-up]')) { e.preventDefault(); setQty(row, q + 1); }
      else if (e.target.closest('[data-qty-down]')) { e.preventDefault(); setQty(row, q - 1); }
    });
    // typing a quantity directly then leaving the field commits it too
    on(form, 'change', function (e) {
      var input = e.target.closest('[data-qty-input], input[name="updates[]"]'); if (!input) return;
      var q = parseInt(input.value, 10); if (isNaN(q) || q < 0) q = 0;
      input.value = q; submitUpdate();
    });
    // a luxury loading affordance on the explicit UPDATE / CHECKOUT submits
    on(form, 'submit', function () { form.classList.add('updating'); });
  })();

  /* T5.1 — no size chosen yet: buy actions route the shopper to the size row instead of adding
     a silent default. Scrolls the row into view, flashes the quiet note, focuses the first live
     chip. Returns true when it intercepted (callers bail). */
  function promptSizeChoice() {
    var root = document.querySelector('[data-product-root]');
    if (!root || !root.classList.contains('tk-needs-size')) return false;
    var chip = root.querySelector('.sizes .size');
    var opt = chip ? chip.closest('.opt') : null;
    var note = root.querySelector('[data-size-note]');
    if (note) { note.hidden = false; note.classList.remove('flash'); void note.offsetWidth; note.classList.add('flash'); }
    // focus BEFORE the glide — html{scroll-behavior:smooth} makes scrollIntoView asynchronous,
    // and Chromium cancels an in-flight smooth scroll on focus() even with preventScroll
    var live = root.querySelector('.sizes .size:not([disabled])');
    if (live) { try { live.focus({ preventScroll: true }); } catch (e) {} }
    if (opt) {
      // instant jump with the CSS smooth override lifted (html{scroll-behavior:smooth} would
      // otherwise re-smooth even behavior:'auto') — used for reduced motion and as the fallback
      var jump = function () {
        var de = document.documentElement, prev = de.style.scrollBehavior;
        de.style.scrollBehavior = 'auto';
        opt.scrollIntoView({ block: 'center' });
        de.style.scrollBehavior = prev;
      };
      if (REDUCE) { jump(); }
      else {
        var y0 = window.pageYOffset;
        opt.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // some engines/settings silently drop smooth scrolls — if nothing moved, land instantly
        setTimeout(function () {
          var r = opt.getBoundingClientRect();
          if (window.pageYOffset === y0 && (r.top < 0 || r.bottom > window.innerHeight)) jump();
        }, 420);
      }
    }
    return true;
  }

  /* product form: add-to-cart + buy-now */
  var pform = document.getElementById('product-form');
  if (pform && !TK.designMode) {
    function currentId() { var i = pform.querySelector('[data-variant-id]'); return i ? i.value : ''; }
    on(pform, 'submit', function (e) {
      e.preventDefault();
      if (promptSizeChoice()) return;
      var id = currentId(); if (!id) return;
      var btn = pform.querySelector('[data-atc]'); if (btn) btn.classList.add('loading');
      addToCart(id, 1).then(function () { return refreshCart(true); }).then(function () { if (btn) btn.classList.remove('loading'); })
        .catch(function (err) { atcError(btn, err); });
    });
    on(pform.querySelector('[data-atc-qty]'), 'click', function () {
      if (promptSizeChoice()) return;
      var id = currentId(); if (!id) return; addToCart(id, 1).then(function () { refreshCart(true); }).catch(function () {});
    });
    on(pform.querySelector('[data-buy-now]'), 'click', function () {
      if (promptSizeChoice()) return;
      var id = currentId(); if (!id) return;
      var nbtn = pform.querySelector('[data-buy-now]'); if (nbtn) nbtn.classList.add('loading');
      addToCart(id, 1).then(function () { window.location.href = '/checkout'; }).catch(function (err) { atcError(nbtn, err); });
    });
  }

  /* ============================================================
     VARIANT PICKER + GALLERY + ACCORDION (PDP)
     ============================================================ */
  (function pdp() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var variants = [];
    try { variants = JSON.parse((document.querySelector('[data-product-json]') || {}).textContent || '[]'); } catch (e) {}
    var idInput = root.querySelector('[data-variant-id]'),
      // scope to the visible price node — the hidden [data-recent-product] carrier ALSO has a
      // data-price attribute and sits first in the DOM, so a bare [data-price] grabs the wrong one
      priceEl = root.querySelector('.price[data-price]'),
      atc = root.querySelector('[data-atc]'),
      buy = root.querySelector('[data-buy-now]'),
      colourLabel = root.querySelector('[data-colour-value]'),
      scarcityEl = root.querySelector('[data-scarcity]'),
      notifyEl = root.querySelector('[data-notify]'),
      lowStock = parseInt(root.getAttribute('data-low-threshold'), 10) || 0;
    var sizeNote = root.querySelector('[data-size-note]');
    var SELECT_SIZE = 'Select a size';

    /* ---- S4: PDP gallery turntable — the fitting drag-scrub on the buy page (3+ images;
       the section toggle gates the markup, so absence of the stage = today's gallery). Drag
       only on every pointer — hover-scrub would fight click-to-zoom on fine pointers. ---- */
    var ttStage = root.querySelector('[data-gallery-turntable]');
    var ttFrames = ttStage ? $$('[data-gframe]', ttStage) : [];
    var ttUI = root.querySelector('[data-gtt-ui]');
    var ttCur = root.querySelector('[data-gtt-cur]');
    var galleryStatus = root.querySelector('[data-gallery-status]');
    var thumbEls = $$('[data-thumb]', root);
    function syncGalleryUI(i) {
      if (ttCur) ttCur.textContent = ('0' + (i + 1)).slice(-2);
      thumbEls.forEach(function (t, k) { t.classList.toggle('on', k === i); });
      if (galleryStatus) galleryStatus.textContent = 'Image ' + (i + 1) + ' of ' + ttFrames.length;
    }
    var galleryTT = (ttStage && ttFrames.length > 2) ? makeTurntable(ttStage, ttFrames, {
      noDrag: true,               // arrows are the primary control now — no drag-scrub
      onChange: syncGalleryUI
    }) : null;
    // LEFT / RIGHT arrows — the main way to browse the gallery. stopPropagation keeps the arrow
    // click from bubbling to the stage's click-to-zoom. Wraps continuously (turntable show()).
    (function galleryArrows() {
      if (!galleryTT) return;
      function step(d) { return function (e) { e.stopPropagation(); galleryTT.show(galleryTT.index() + d); }; }
      on(root.querySelector('[data-gtt-prev]'), 'click', step(-1));
      on(root.querySelector('[data-gtt-next]'), 'click', step(1));
    })();
    // the image currently on the stage (turntable frame or the classic single main image)
    function activeGalleryImg() {
      if (galleryTT) { var f = ttFrames[galleryTT.index()]; return f ? f.querySelector('img') : null; }
      return document.getElementById('pdpmain');
    }
    function updateScarcity(v) {
      if (!scarcityEl) return;
      var q = v && v.inventory_quantity, mgmt = v && v.inventory_management;
      if (v && v.available && mgmt && typeof q === 'number' && q > 0 && q <= lowStock) {
        scarcityEl.innerHTML = '<span class="scarcity-dot" aria-hidden="true"></span>' + (q === 1 ? 'Final piece' : 'Only ' + q + ' remaining');
        scarcityEl.hidden = false;
      } else { scarcityEl.hidden = true; }
    }
    function selected() {
      return $$('.opt', root).map(function (g) {
        var on = g.querySelector('.sw.on, .size.on'); return on ? on.getAttribute('data-value') : null;
      });
    }
    function optsOf(v) { return v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }); }
    function match(sel) {
      return variants.find(function (v) {
        var opts = optsOf(v);
        return sel.every(function (s, i) { return String(opts[i]) === String(s); });
      });
    }
    // SOLD-OUT per size — mark each size option whose variant can never add to cart given the
    // OTHER axes currently chosen (multi-axis aware: a size sold out in the picked colour reads
    // as sold out). Strikes through + disables so it can't be selected; aria-disabled for AT.
    // Re-evaluated on every change so switching colour re-flows which sizes are gone.
    function markSoldOut() {
      if (!variants.length) return;
      var sel = selected();
      $$('.opt', root).forEach(function (grp) {
        var btns = $$('.size', grp); if (!btns.length) return;   // size groups only; swatches untouched
        var idx = (parseInt(grp.getAttribute('data-option-index'), 10) || 1) - 1;
        btns.forEach(function (b) {
          var val = b.getAttribute('data-value');
          // any variant that matches this size AND the other picked axes, and is in stock
          var live = variants.some(function (v) {
            var opts = optsOf(v);
            if (String(opts[idx]) !== String(val)) return false;
            var okOthers = sel.every(function (s, i) { return i === idx || s == null || String(opts[i]) === String(s); });
            return okOthers && v.available;
          });
          b.classList.toggle('soldout', !live);
          if (live) { b.removeAttribute('aria-disabled'); if (!b.classList.contains('on')) b.disabled = false; }
          else { b.setAttribute('aria-disabled', 'true'); b.disabled = true; }
        });
      });
    }
    function update() {
      var sel = selected(), v = match(sel);
      if (colourLabel && sel[0]) colourLabel.textContent = sel[0];
      markSoldOut();
      // T5.1 — explicit size selection: while any axis is unchosen nothing can be bought.
      // ATC reads "Select a size" (disabled), Buy Now disables, express hides (root class → CSS),
      // scarcity stays quiet. Exception: every size struck out for the picked axes = un-buyable —
      // the column flips to Sold Out + notify (parity with the fully-sold-out preselect flow).
      var unchosen = sel.some(function (s) { return s == null; });
      root.classList.toggle('tk-needs-size', unchosen);
      if (sizeNote) sizeNote.hidden = !unchosen;
      if (unchosen) {
        var allGone = $$('.opt', root).some(function (g) {
          var sb = $$('.size', g);
          return sb.length > 0 && sb.every(function (b) { return b.disabled; });
        });
        if (atc) { atc.disabled = true; atc.textContent = allGone ? 'Sold Out' : SELECT_SIZE; }
        if (buy) buy.disabled = true;
        if (notifyEl) notifyEl.hidden = !allGone;
        if (scarcityEl) scarcityEl.hidden = true;
        return;
      }
      if (notifyEl) notifyEl.hidden = !!(v && v.available);
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } if (buy) buy.disabled = true; return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ' <s class="was">' + formatMoney(v.compare_at_price) + '</s>' : '');
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
      if (buy) buy.disabled = !v.available;
      updateScarcity(v);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
      // swap the main gallery image to the chosen variant's media. On the turntable the variant's
      // frame already exists at full srcset — jump to it. Classic gallery: rebuild srcset too —
      // setting .src alone leaves the stale srcset, which wins on responsive viewports (the swap
      // would silently show the original image on most screens).
      if (v.featured_media && v.featured_media.preview_image) {
        if (galleryTT) {
          for (var fi = 0; fi < ttFrames.length; fi++) {
            if (ttFrames[fi].getAttribute('data-media-id') === String(v.featured_media.id)) { galleryTT.show(fi); break; }
          }
        } else {
          var m = document.getElementById('pdpmain');
          if (m) {
            var src = v.featured_media.preview_image.src, q = src.indexOf('?') > -1 ? '&' : '?';
            m.srcset = src + q + 'width=800 800w, ' + src + q + 'width=1200 1200w, ' + src + q + 'width=1600 1600w';
            m.src = src + q + 'width=1600';
          }
        }
      }
    }
    on(root, 'click', function (e) {
      var b = e.target.closest('.sw, .size'); if (!b) return;
      if (b.disabled || b.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }  // a sold-out size can't be picked
      var grp = b.classList.contains('sw') ? '.sw' : '.size';
      $$(grp, b.closest('.opt')).forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on'); update();
    });
    // only SIZE is an explicit choice (T5.1): a colour axis with nothing lit self-selects its
    // first swatch (matches Liquid's selected_value render; covers previews/edge data), and a
    // single-value size axis self-selects (Liquid preselects it too; this covers stale caches)
    $$('.opt', root).forEach(function (g) {
      var sw0 = g.querySelector('.sw');
      if (sw0 && !g.querySelector('.sw.on')) sw0.classList.add('on');
      var sb = $$('.size', g);
      if (sb.length === 1 && !g.querySelector('.size.on')) sb[0].classList.add('on');
    });
    markSoldOut();   // mark sold-out sizes at render, before any interaction
    // gallery thumbnails swap main — on the turntable a thumb simply selects its frame
    $$('[data-thumb]', root).forEach(function (t, ti) {
      on(t, 'click', function () {
        if (galleryTT) { galleryTT.show(ti); return; }
        $$('[data-thumb]', root).forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var main = document.getElementById('pdpmain');
        if (main) {
          // mirror the variant-swap path above: rebuild srcset too — setting .src alone leaves the
          // stale srcset, which wins on responsive viewports (the click would be a visual no-op).
          // data-full may carry a ?width= from image_url — strip it before building candidates.
          var src = t.getAttribute('data-full').replace(/([?&])width=\d+(&|$)/, function (_, p, tail) { return tail ? p : ''; });
          var q = src.indexOf('?') > -1 ? '&' : '?';
          main.srcset = src + q + 'width=800 800w, ' + src + q + 'width=1200 1200w, ' + src + q + 'width=1600 1600w';
          main.src = src + q + 'width=1600';
        }
      });
    });
    // thumbnail rail prev/next arrows — step the active thumb (wraps; the controls rendered but had no handler)
    function stepThumb(d) {
      var ts = $$('[data-thumb]', root); if (!ts.length) return;
      var cur = 0;
      ts.forEach(function (t, i) { if (t.classList.contains('on')) cur = i; });
      ts[(cur + d + ts.length) % ts.length].click();
    }
    on(root.querySelector('[data-thumb-prev]'), 'click', function () { stepThumb(-1); });
    on(root.querySelector('[data-thumb-next]'), 'click', function () { stepThumb(1); });
    // CLICK-TO-ZOOM — honour the cursor:zoom-in the gallery already shows. A self-contained
    // lightbox (own overlay, no markup/CSS dependency) shows the image currently in the main
    // frame at full resolution. Esc / click / the close control dismiss it; scroll-locked while
    // open; reduced-motion safe (no transition relied upon). Keyboard: the frame is focusable
    // and Enter/Space opens it.
    (function galleryZoom() {
      var mainFrame = root.querySelector('.gallery .main');
      var mainImg = document.getElementById('pdpmain');
      if (!mainFrame || !mainImg) return;
      var box = null, lbImg = null, zoomOpen = false;
      function build() {
        box = document.createElement('div');
        box.className = 'tk-zoom';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('aria-label', 'Product image — enlarged');
        // fixed dark scrim (NOT --void-rgb, which is near-white on the light-only shop pages — that
        // let the page bleed through behind the enlarged image). A lightbox is always a dark surround.
        box.style.cssText = 'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;padding:5vmin;background:rgb(8 11 14 / .96);opacity:0;transition:opacity .4s ease;cursor:zoom-out';
        lbImg = document.createElement('img');
        lbImg.alt = mainImg.getAttribute('alt') || '';
        lbImg.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;clip-path:polygon(0 1.5%,100% 0,100% 98.5%,0 100%)';
        var close = document.createElement('button');
        close.type = 'button';
        close.setAttribute('aria-label', 'Close enlarged image');
        close.textContent = '×';
        close.style.cssText = 'position:absolute;top:3vmin;right:4vmin;background:none;border:0;color:#f4f6f8;font-size:34px;line-height:1;cursor:pointer';
        box.appendChild(lbImg); box.appendChild(close);
        document.body.appendChild(box);
        on(box, 'click', closeZoom);
      }
      function openZoom() {
        var img = activeGalleryImg() || mainImg;   // turntable: zoom the frame on stage, not frame 0
        if (!img || !img.getAttribute('src')) return;
        if (!box) build();
        lbImg.src = img.currentSrc || img.src;
        lbImg.alt = img.getAttribute('alt') || '';
        zoomOpen = true; openOverlays.zoom = true; setLock();
        box.style.display = 'flex';
        requestAnimationFrame(function () { box.style.opacity = '1'; });
      }
      function closeZoom() {
        if (!zoomOpen || !box) return;
        zoomOpen = false; openOverlays.zoom = false; setLock();
        box.style.opacity = '0';
        var hide = function () { if (box) box.style.display = 'none'; };
        REDUCE ? hide() : setTimeout(hide, 400);
      }
      mainFrame.setAttribute('tabindex', '0');
      mainFrame.setAttribute('role', 'button');
      // the turntable stage ships its own label (drag/arrows/Enter); don't clobber it
      if (!mainFrame.getAttribute('aria-label')) mainFrame.setAttribute('aria-label', 'Enlarge product image');
      on(mainFrame, 'click', openZoom);
      on(mainFrame, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openZoom(); } });
      on(document, 'keydown', function (e) { if (e.key === 'Escape' && zoomOpen) closeZoom(); });
    })();
    // accordion
    $$('[data-acc-q]', root).forEach(function (q) {
      on(q, 'click', function () { q.parentNode.classList.toggle('open'); });
    });
  })();

  /* ============================================================
     STICKY ADD-TO-CART — surfaces the buy action once the main
     buy box scrolls away (mobile especially). Proxies the form.
     ============================================================ */
  (function pdpSticky() {
    var bar = document.querySelector('[data-pdp-sticky]');
    var root = document.querySelector('[data-product-root]');
    if (!bar || !root) return;
    var mainAtc = root.querySelector('[data-atc]');
    // .price scope: the hidden [data-recent-product] div also carries a data-price ATTRIBUTE and
    // precedes the real price in the DOM — a bare [data-price] would mirror an empty string
    var mainPrice = root.querySelector('.price[data-price]');
    var actions = root.querySelector('.actions') || mainAtc;
    var psPrice = bar.querySelector('[data-ps-price]');
    var psAdd = bar.querySelector('[data-ps-add]');
    function mainSizes() { return $$('.sizes .size', root); }
    function mirror() {
      if (psPrice && mainPrice) psPrice.textContent = mainPrice.textContent.trim();
      if (psAdd && mainAtc) {
        // gated (no size chosen) the sticky Add stays TAPPABLE — its tap opens the size row
        var gated = root.classList.contains('tk-needs-size');
        psAdd.disabled = mainAtc.disabled && !gated;
        psAdd.textContent = mainAtc.textContent.trim();
      }
      var ms = mainSizes();
      $$('[data-ps-size]', bar).forEach(function (ps) {
        var v = ps.getAttribute('data-ps-size');
        var m = ms.filter(function (x) { return x.getAttribute('data-value') === v; })[0];
        ps.classList.toggle('on', !!(m && m.classList.contains('on')));
        ps.classList.toggle('soldout', !!(m && m.disabled));
      });
    }
    var pastBuy = false, nearEnd = false;
    function apply() {
      var show = pastBuy && !nearEnd;
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if ('IntersectionObserver' in window && actions) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { pastBuy = !en.isIntersecting; apply(); });
      }, { rootMargin: '-8% 0px -8% 0px' }).observe(actions);
      var footer = document.querySelector('footer');
      if (footer) new IntersectionObserver(function (es) {
        es.forEach(function (en) { nearEnd = en.isIntersecting; apply(); });
      }).observe(footer);
    }
    on(bar, 'click', function (e) {
      var s = e.target.closest('[data-ps-size]');
      if (s) {
        var v = s.getAttribute('data-ps-size');
        var m = mainSizes().filter(function (x) { return x.getAttribute('data-value') === v; })[0];
        if (m) m.click();
        mirror();
        return;
      }
      if (e.target.closest('[data-ps-add]')) {
        // T5.1 mobile flow: no size chosen → the sticky Add surfaces the size row (≤640px hides
        // the ps-size chips), scrolling to it with the note — never a silent default add.
        if (promptSizeChoice()) return;
        if (mainAtc && !mainAtc.disabled) mainAtc.click();
      }
    });
    on(root, 'click', function (e) { if (e.target.closest('.sw, .size')) setTimeout(mirror, 0); });
    if (mainPrice) { try { new MutationObserver(mirror).observe(mainPrice, { childList: true, subtree: true, characterData: true }); } catch (e) {} }
    mirror();
  })();

  /* ============================================================
     PAGE TRANSITIONS — angular wipe + sigil flash (reduced-motion = instant)
     ============================================================ */
  (function transitions() {
    // THE CUT runs on native cross-document View Transitions (sigil-motion-head.liquid) — no click
    // interception, no navigation delay. Here we only answer the click AT ONCE: a light veil
    // (composited opacity) so the page responds while the next one loads; the cut takes over from it.
    try { sessionStorage.removeItem('tk_wipe'); } catch (e) {}
    if (TK.designMode || REDUCE) return;
    var d = document.documentElement, t;
    function clear() { d.classList.remove('tk-leave'); clearTimeout(t); }
    on(document, 'click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var a = e.target.closest('a[href]'); if (!a || e.target.closest('button')) return;
      if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-cart-open') || a.hasAttribute('data-search-open') || a.hasAttribute('data-ic-open')) return;
      var u; try { u = new URL(a.href); } catch (er) { return; }
      if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search) || u.hash && u.pathname === location.pathname) return;
      if (/^\/(cart|checkout|checkouts|account)/.test(u.pathname)) return;
      var HELP = /^\/pages\/(size-fit|shipping-returns|faq|contact)\/?$/;
      if (HELP.test(location.pathname) && HELP.test(u.pathname)) return;   // support pages just switch — no veil
      // let other handlers (cart/quick-add) decide first; only veil a navigation that will really happen
      setTimeout(function () { if (!e.defaultPrevented) { d.classList.add('tk-leave'); t = setTimeout(clear, 2500); } }, 0);
    });
    on(window, 'pageshow', clear);
    on(window, 'pagehide', clear);
  })();

  /* ============================================================
     EMAIL CAPTURE — Inner Circle pop-up + footer newsletter (Shopify-native)
     ============================================================ */
  var IC = TK.ic || {};
  function icSuppressed() {
    try { var t = localStorage.getItem('tk_ic_seen'); return t && (Date.now() - parseInt(t, 10)) < (IC.suppress || 24) * 3600000; } catch (e) { return false; }
  }
  function icMarkSeen() { try { localStorage.setItem('tk_ic_seen', String(Date.now())); } catch (e) {} }
  var icShown = false;
  function openIC(force) {
    var s = document.getElementById('icscrim'); if (!s) return;
    if (!force && (icShown || icSuppressed() || TK.designMode)) return;
    icShown = true;
    var box = document.getElementById('icbox'); if (box) box.classList.remove('sent');
    var em = document.querySelector('[data-ic-email]'); if (em) { em.value = ''; }
    lastFocus = document.activeElement; activeScrim = s;
    s.classList.add('open'); openOverlays.ic = true; setLock();
    if (em) setTimeout(function () { try { em.focus(); } catch (e) {} }, 280);
    if (!force) icMarkSeen();
  }
  function closeIC() { closeOverlay('icscrim', 'ic'); }

  // inline status line — surfaces a retry/error message without depending on markup that
  // may not exist. Created lazily next to the field, cleared on the next attempt. Uses only
  // tokenised colour so it reads correctly in both editions; aria-live so AT announces it.
  function formStatus(form) {
    var s = form.querySelector('[data-tk-formstatus]');
    if (!s) {
      s = document.createElement('div');
      s.setAttribute('data-tk-formstatus', '');
      s.setAttribute('role', 'status');
      s.setAttribute('aria-live', 'polite');
      s.style.cssText = 'font-family:var(--ui);font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:rgb(var(--accent-rgb) / .92);margin-top:10px;min-height:1em';
      var anchor = form.querySelector('.icform, .footnewsform') || form;
      anchor.parentNode ? anchor.parentNode.insertBefore(s, anchor.nextSibling) : form.appendChild(s);
    }
    return s;
  }
  // Shopify-native submit: validate, POST the customer form, and report the REAL outcome.
  // onDone(true) ONLY on a genuine 2xx response; onDone(false) on a non-OK status, a network
  // failure, or a thrown error — so a failed POST can never masquerade as a successful join.
  function submitCustomerForm(form, onDone) {
    var em = form.querySelector('input[type=email]');
    var val = em ? em.value.trim() : '';
    if (!validEmail(val)) { if (em) { em.focus(); em.setAttribute('placeholder', 'Enter a valid email'); } return false; }
    formStatus(form).textContent = '';
    var done = function (ok) { try { onDone(ok); } catch (e) {} };
    try {
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { done(!!(r && r.ok)); })
        .catch(function () { done(false); });
    } catch (e) { done(false); }
    return true;
  }
  // restore a submit button from its loading/disabled state after an attempt resolves
  function clearSubmitting(form) {
    var b = form.querySelector('button[type=submit], [type=submit]');
    if (b) { b.classList.remove('loading'); b.disabled = false; }
  }
  // Inner Circle form
  var icForm = (function () { var s = document.getElementById('icbox'); return s ? s.querySelector('form') : null; })();
  if (icForm) {
    on(icForm, 'submit', function (e) {
      e.preventDefault();
      var btn = icForm.querySelector('.icbtn');
      if (btn) { btn.classList.add('loading'); btn.disabled = true; }
      var sent = submitCustomerForm(icForm, function (ok) {
        clearSubmitting(icForm);
        if (ok) {
          var box = document.getElementById('icbox');
          // reveal the code only now (it ships encoded, never as page text)
          var cb = box && box.querySelector('[data-ic-c]'), hasCode = false;
          if (cb) { try { var code = atob(cb.getAttribute('data-ic-c')); if (code) { cb.setAttribute('data-code', code); var cv = cb.querySelector('.iccode-val'); if (cv) cv.textContent = code; hasCode = true; } } catch (er) {} }
          if (box) box.classList.add('sent');
          icMarkSeen();
          if (!hasCode) setTimeout(closeIC, 2600);   // with a code, stay open so it can be copied
        } else {
          formStatus(icForm).textContent = 'Could not join — please try again';
          var em = document.querySelector('[data-ic-email]'); if (em) try { em.focus(); } catch (_) {}
        }
      });
      if (!sent && btn) { btn.classList.remove('loading'); btn.disabled = false; }
    });
  }
  // Footer newsletter form
  $$('[data-news-email]').forEach(function (input) {
    var form = input.closest('form'); if (!form) return;
    on(form, 'submit', function (e) {
      e.preventDefault();
      var nbtn = form.querySelector('button[type=submit], [type=submit]');
      if (nbtn) { nbtn.classList.add('loading'); nbtn.disabled = true; }
      var sent = submitCustomerForm(form, function (ok) {
        clearSubmitting(form);
        if (ok) {
          var done = form.querySelector('[data-news-done]'); if (done) done.classList.add('show');
          formStatus(form).textContent = '';
          form.reset();
        } else {
          formStatus(form).textContent = 'Could not subscribe — please try again';
          try { input.focus(); } catch (_) {}
        }
      });
      if (!sent && nbtn) { nbtn.classList.remove('loading'); nbtn.disabled = false; }
    });
  });
  // triggers — entry timer (retired → 50% scroll depth) · exit-intent; once per window.
  // CALM by design (Stillroom): nothing may ambush a browsing shopper.
  //  · NEVER on product or cart pages — those are moments of choice; nothing covers them.
  //  · everywhere else the ONLY passive trigger is reading depth: 50% of the page scrolled,
  //    after a settle grace, never while any drawer/overlay is open (it waits and re-checks).
  //  · suppressed for at least 14 days once shown/closed — a shorter merchant setting is
  //    overridden upward (Math.max); a longer one is honoured. openIC() marks it seen on open.
  //  · exit-intent is desktop-only (fine pointer + hover) and demands a deliberate UPWARD exit.
  // The legacy timer settings (ic_trigger_entry / ic_delay / ic_trigger_product / ic_product_delay)
  // now simply gate the depth trigger: if the merchant turned BOTH off, no passive trigger arms.
  // openIC / closeIC API is unchanged.
  IC.suppress = Math.max(IC.suppress || 0, 14 * 24);   // hours — floor of 14 days
  var icBody = document.body.classList;
  var icBlockedPage = icBody.contains('template-product') || icBody.contains('template-cart');
  if (IC.enabled && !TK.designMode && !icBlockedPage && !icSuppressed()) {
    var IC_GRACE = 4000;          // a settle window after load before ANY auto-trigger may arm
    var loadAt = Date.now();
    var pastGrace = function () { return Date.now() - loadAt >= IC_GRACE; };
    var anyOverlayOpen = function () {
      for (var k in openOverlays) { if (openOverlays[k]) return true; }
      return !!document.querySelector('.cartscrim.open, .wishscrim.open, .sgscrim.open, .searchscrim.open, .menuscrim.open');
    };
    if (IC.triggerEntry !== false || IC.triggerProduct !== false) {
      var depthFired = false, depthTick = null;
      var onDepth = function () {
        if (depthFired || icShown) return;
        if (!pastGrace() || anyOverlayOpen()) {   // re-check once things settle / the drawer closes
          if (!depthTick) depthTick = setTimeout(function () { depthTick = null; onDepth(); }, 1200);
          return;
        }
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.pageYOffset / h >= 0.5) {
          depthFired = true;
          window.removeEventListener('scroll', onDepth);
          openIC(false);
        }
      };
      on(window, 'scroll', onDepth, { passive: true });
    }
    var icDesktop = false;
    try { icDesktop = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)').matches; } catch (e) {}
    if (IC.exit && icDesktop) {
      // pointer leaving past the top edge, moving UP at speed, after the grace window,
      // never over an open drawer, debounced to one shot per window.
      var exitLastY = null, exitFired = false;
      on(document, 'mousemove', function (e) { exitLastY = e.clientY; }, { passive: true });
      on(document, 'mouseout', function (e) {
        if (exitFired || icShown || !pastGrace() || anyOverlayOpen()) return;
        if (e.relatedTarget || e.clientY > 8) return;                 // only the true top edge
        if (exitLastY != null && e.clientY - exitLastY > -6) return;  // must be travelling UPWARD
        exitFired = true;
        openIC(false);
      });
    }
    // NOTE: size selection deliberately does NOT fire the pop-up, and no timer ever does.
  }
  // copy the discount code from the revealed chip
  on(document, 'click', function (e) {
    var btn = e.target.closest('[data-ic-copy]'); if (!btn) return;
    var code = btn.getAttribute('data-code') || '';
    try { if (navigator.clipboard) navigator.clipboard.writeText(code); } catch (_) {}
    btn.classList.add('copied');
    var c = btn.querySelector('.iccode-copy'); if (c) c.textContent = 'copied';
  });

  // localization (Shopify Markets) — click a trigger to open its region/language panel.
  // Choosing a country/language is a NATIVE submit button inside the form (no JS to switch).
  function closeLoc(except) {
    $$('.locform[data-open]').forEach(function (f) {
      if (f === except) return;
      f.removeAttribute('data-open');
      var b = f.querySelector('[data-loc-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  on(document, 'click', function (e) {
    var tog = e.target.closest('[data-loc-toggle]');
    if (tog) {
      var form = tog.closest('.locform'); if (!form) return;
      var isOpen = form.hasAttribute('data-open');
      closeLoc(form);
      if (isOpen) { form.removeAttribute('data-open'); tog.setAttribute('aria-expanded', 'false'); }
      else { form.setAttribute('data-open', ''); tog.setAttribute('aria-expanded', 'true'); }
      return;
    }
    if (!e.target.closest('.locpanel')) closeLoc(null);
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') closeLoc(null); });

  // Journal — copy-link on the article share row (progressive: falls back to a
  // plain "COPIED" acknowledgement if the clipboard API is unavailable).
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-share-copy]');
    if (!b) return;
    var u = b.getAttribute('data-url') || location.href;
    var l = b.querySelector('[data-share-copy-label]');
    var done = function () {
      if (!l || l.dataset.busy) return;
      l.dataset.busy = '1';
      var t = l.textContent;
      l.textContent = 'COPIED';
      setTimeout(function () { l.textContent = t; delete l.dataset.busy; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(u).then(done, done);
    else done();
  });

  // expose a tiny API for inline fallbacks / debugging
  window.TOMASHKO_RUN = { openCart: openCart, refreshCart: refreshCart, openIC: openIC };
})();
